import styled from 'styled-components';

const ContentGrid = styled.div`
  display: grid;
  /* Default (sm): <= 320px */
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  padding: 16px 32px;

  /* md: > 320px and <= 412px */
  @media (min-width: 321px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px 10px;
    padding: 16px;
  }

  /* lg: > 412px */
  @media (min-width: 413px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
  }
`;

export default ContentGrid;
